'use strict';

$(() => {
  const $mpp = $('.mpp-container');
  return $mpp.find('.small-map').click(() => {
    let $target = $mpp.find('.offers-map');

    if (!($target.length > 0)) {
      $target = $mpp.find('.nearby-deals');
    }

    if (!($target.length > 0)) {
      return null;
    }

    return $('body').scrollTo($target, 400);
  });
});
